const options = {
  controls: [
    'play-large', // 中间的大播放按钮
    'play', // 播放/暂停播放
    'progress', // 播放和缓冲的进度条和滑动条
    'current-time', // 播放的当前时间
    'mute', // 切换静音
    'volume', // 音量控制
    'fullscreen' // 切换全屏
  ],
  muted: true //播放默认静音播放
}

const bodyStyle = {
  padding: 0
}

module.exports = {
  options,
  bodyStyle
}
